// extracted by mini-css-extract-plugin
export default {"about_page":"about_about_page__Fd6nm","about_content":"about_about_content__esZpe"};